/* eslint-disable no-unused-vars */
import { ModalBase } from 'components';
import { GeneralModalUI } from './generalModalUi/GeneralModalUI';
import { CroppingImgUI } from './croppingImgUI/CroppingImgUI';
import { useSignal } from '@preact/signals-react';

export const ChooseCreativeModal = ({ open, handleClose, creativeModalType }) => {
  const selectedFile$ = useSignal(false);

  return (
    <>
      {open && (
        <ModalBase>
          {!selectedFile$.value ? (
            <GeneralModalUI
              handleClose={handleClose}
              creativeModalType={creativeModalType}
              selectedFile$={selectedFile$}
            />
          ) : (
            <CroppingImgUI
              creativeModalType={creativeModalType}
              selectedFile$={selectedFile$}
              handleClose={() => (selectedFile$.value = false)}
            />
          )}
        </ModalBase>
      )}
    </>
  );
};
